const DEFAULT_CATEGORY_ID = 0;

const DEFAULT_CATEGORY_NAME = 'Uncategorised';

export {
  DEFAULT_CATEGORY_ID,
  DEFAULT_CATEGORY_NAME,
};
